import React, { useState } from "react";
import styled from "styled-components";
import AttendanceHome from "Pages/MySchedule/Attendance/AttendanceHome";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import AttendanceStatsGrid, { AttendanceStats } from "./AttendanceStatsGrid";
import { LectureData } from "Pages/MyScheduleBeta/LectureDetails/LectureTypes";
import { inBetweenTime } from "utilFunctions/shared/ScheduleStatus";

const DEFAULT_ATTENDANCE_STATS: AttendanceStats = {
  present: 0,
  absent: 0,
  online: 0,
  pending: 0,
};
interface AttendanceTabProps {
  lecture?: LectureData;
}

const ScopedAttendanceWrapper = styled.div<{ isDesktop: boolean }>`
  width: 100%;
  button.btn-aeslDraft,
  button.buttonHeight,
  #Tooltip-student-attendance-button {
    background-color: var(--primary-text) !important;
  }
  .attendanceCardFooter {
    height: 60px !important;
  }
  ${(props) =>
    props.isDesktop
      ? `
      > div {
        padding-left: 0 !important;
      }

      .mt-3,
      .my-3 {
        margin-top: 0 !important;
      }

      .mb-3,
      .my-3 {
        margin-bottom: 0 !important;
      }

      .ant-input-affix-wrapper,
      input[placeholder*="Search"],
      div:has(> input[placeholder*="Search"]) {
        max-width: 360px !important;
        margin-left: auto !important;
      }
    `
      : `
      div:has(> button.btn-aeslDraft),
      div:has(> button.buttonHeight) {
        width: 100% !important;
        left: 0 !important;
        right: 0 !important;
        padding: 0 !important;
        box-sizing: border-box !important;
      }

      button.btn-aeslDraft,
      button.buttonHeight {
        width: 100% !important;
        border-radius: 0 !important;
        height: 40px !important;
        font-size: 14px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
    `}
`;

const AttendanceTab: React.FC<AttendanceTabProps> = ({ lecture }) => {
  const [attendanceStats, setAttendanceStats] = useState<AttendanceStats>(
    DEFAULT_ATTENDANCE_STATS
  );

  const { screen } = useWindowSize();
  const isMobile = screen === "sm";
  const isShowAttendance = (cardViewData: LectureData) => {
    let isShow = false;
    if (
      new Date(new Date()) <
      new Date(cardViewData?.endTime as string | number | Date)
    ) {
      if (inBetweenTime(cardViewData?.startTime, cardViewData?.endTime)) {
        isShow = false;
      } else {
        isShow = true;
      }
    }
    return isShow;
  };
  return (
    <div style={{ width: "100%" }}>
      {isMobile && <AttendanceStatsGrid stats={attendanceStats} />}

      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          paddingTop: "0px",
        }}
      >
        <ScopedAttendanceWrapper isDesktop={!isMobile}>
          <AttendanceHome
            showOnlySearchHeader
            notShowFooter={isMobile}
            onStatsChange={setAttendanceStats}
            isHideAttendanceButton={isShowAttendance(lecture as LectureData)}
            courseId={lecture?.courseId}
          />
        </ScopedAttendanceWrapper>
      </div>
    </div>
  );
};

export default AttendanceTab;
